import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation } from '@tanstack/react-query'

export interface SepaExportParams {
  year: number
  month: number
}

async function downloadSepaExport({ year, month }: SepaExportParams) {
  const response = await apiClient.get(`${SNA_PREFIX}rents/sepa-export`, {
    params: { year, month },
    responseType: 'blob'
  })

  const contentDisposition = response.headers['content-disposition']
  let filename = `SLSP_SEPA_${year}${String(month).padStart(2, '0')}.xml`

  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="(.+)"/)
    if (filenameMatch) {
      filename = filenameMatch[1]
    }
  }

  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

export function useSepaExport() {
  return useMutation({
    mutationFn: downloadSepaExport
  })
}
